import React from 'react';
import SectionHeader from '../ui/SectionHeader';
import STAR_SIGNS from '../../data/star_signs'

// ─── STEP 4: STAR SIGN ──────────────────────────────────────────────────────
function StarSignStep({ character, setCharacter }) {
  return (
    <div>
      <SectionHeader>Choose Your Star Sign</SectionHeader>
      <p style={{ fontSize: "13px", color: "#8a7e5e", marginBottom: 18, lineHeight: 1.5 }}>
        The constellation you were born under grants a unique blessing. Choose one — or let fate decide with a D20!
      </p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))", gap: "8px" }}>
        {STAR_SIGNS.map(sign => {
          const isSelected = character.starSign === sign.id;
          return (
            <button key={sign.id} onClick={() => setCharacter({ ...character, starSign: sign.id })}
              style={{
                background: isSelected ? "linear-gradient(180deg, #2a1f0e, #1a1510)" : "rgba(20,16,10,0.5)",
                border: isSelected ? "1px solid #c9a84c" : "1px solid rgba(201,168,76,0.15)",
                borderRadius: 8, padding: "12px 14px", cursor: "pointer", textAlign: "left", transition: "all 0.2s", color: "#e8dcc8"
              }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 4 }}>
                <span style={{ fontFamily: "'Cinzel', serif", fontSize: "13px", color: isSelected ? "#c9a84c" : "#a08d4e" }}>{sign.name}</span>
                <span style={{ fontSize: "9px", color: "#5a5040" }}>{sign.image}</span>
              </div>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: "10px", color: "#6b6048", fontStyle: "italic", marginBottom: 4 }}>"{sign.title}"</div>
              <div style={{ fontSize: "11px", color: "#8a7e5e", lineHeight: 1.4 }}>{sign.effect}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default StarSignStep
